import type { ApiModuleEndpoints } from '../types'

export const tablePricingApiEndpoints = {
  list: {
    method: 'GET',
    path: '/table-price-assignments',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/table-price-assignments/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/table-price-assignments',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/table-price-assignments/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/table-price-assignments/:id',
    requiresAuth: true,
  },
  preview: {
    method: 'POST',
    path: '/table-pricing/preview',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
